import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Checkbox } from '@/js/libs/ui/src/V2';

import { stopPropagation } from 'src/utils/stopPropagation';
import type { ColumnProps } from '../../types';

export const SelectionCell: React.FC<ColumnProps> = React.memo(function SelectionCell({ item, selection, selectionDisabled }) {
  const checked = React.useMemo(() => selection?.isSelected(item), [item, selection]);

  const handleChange = useCallbackRef<React.ChangeEventHandler<HTMLInputElement>>(() => {
    if (item.id) {
      selection?.toggleId(item.id);
    }
  });

  if (!selection) {
    return null;
  }

  return <Checkbox checked={checked} onChange={handleChange} onClick={stopPropagation} disabled={selectionDisabled} />;
});
